import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel-flow-feedback" }
const _hoisted_2 = { class: "cancel-flow-popup__footer" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import type { ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowFeedback',
  props: {
    billing: {},
    canceling: { type: Boolean },
    reason: {}
  },
  emits: ["send", "continueCancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const router = useRouter()
const feedbackText = ref('')

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'feedback', props.reason)
})

function trackButtonClick(button: string): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feedback',
    button,
    props.reason,
  )
}

function onSupport(): void {
  trackButtonClick('support')
  router.push({ name: 'help' })
}

function onSendFeedback(): void {
  trackButtonClick('send_feedback')
  emit('send', feedbackText.value)
}

function onEndMembership(): void {
  trackButtonClick('end_membership')
  emit('continueCancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "cancel-flow-feedback__subtitle" }, " We carefully review user feedback to make Shortform better ", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((feedbackText).value = $event)),
        class: "cancel-flow-feedback__field",
        maxlength: "1000",
        placeholder: "Any issues, feedback, or suggestions..."
      }, null, 512), [
        [_vModelText, feedbackText.value]
      ]),
      _createElementVNode("button", {
        class: "cancel-flow-feedback__support",
        onClick: onSupport
      }, " Get help from Support ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppButton, {
        loading: __props.canceling,
        disabled: __props.canceling,
        class: "cancel-flow-popup__cta",
        onClick: onSendFeedback
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Send feedback ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createVNode(AppButton, {
        danger: true,
        loading: __props.canceling,
        disabled: __props.canceling,
        class: "cancel-flow-popup__cta",
        onClick: onEndMembership
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" End my membership ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})